export default class ExternalLoginPage {
    constructor() {
        return {
            template: ``,
            controller: ExternalLoginController
        }
    }
}

class ExternalLoginController {

    constructor($rootScope, $scope) {
        $rootScope.$broadcast('event:externalLogin.show');

        $scope.$on('event:auth.loginRequired', () => {
            window.location.href = '/v5/#/auth/external';
        });

        this.$onDestroy = () => {
            $rootScope.$broadcast('event:externalLogin.hide');
        }
    }
}

